import React, { Component } from 'react';
import { APP_URL_API } from '../../setup/configs'
import { withRouter } from 'react-router-dom';
import FileUploadActions from '../admin/organization/sections/FileUploadActions';
import Modal from '../../ui/modal/Modal';
import DonationFile from './DonationFile'
import DeleteDonationsFile from './DeleteDonationsFile';
import Lock from './Lock';
import DonationsMeta from './DonationsMeta'
import axios from 'axios';
var fileDownload = require('js-file-download');

class Donations extends Component {
    constructor(props) {
        super(props)

        this.state = {
            accept: false,
            gdpr: false,
            currentDonation: false,
            donationWaitingForApproval: false,
            currentAnnualReport: false,
            currentAnnualReportContent: this.props.currentAnnualReport,
            locked: false
        }
    }

    componentDidMount() {
        this.setState({
            currentDonation: this.props.currentDonationName ? true : false,
            currentAnnualReport: this.props.currentAnnualReportName ? true : false,
            donationWaitingForApproval: this.props.donationWaitingForApproval ? true : false,
        })
    }

    componentDidUpdate(prevProps) {
        // Check if the relevant props have changed
        if (
          (this.props.currentDonation && this.props.currentDonation.unlocked !== prevProps.currentDonation.unlocked) ||
          this.props.advancedInterface !== prevProps.advancedInterface ||
          (this.props.currentAnnualReport && this.props.currentAnnualReport.unlocked !== prevProps.currentAnnualReport.unlocked)
        ) {
          // Update the state based on the new prop values
          this.setState({
            locked:
              (this.props.currentDonation && this.props.currentDonation.unlocked === 0) ||
              (!this.props.advancedInterface && this.props.currentAnnualReport && this.props.currentAnnualReport.unlocked === 0)
                ? true
                : false,
          });
        }
      }      

    handleUnLock = (documentType) => {
        this.setState({
            locked: false
        }, this.props.onHandleLockingDocument('unlock', documentType))
    }
    
    handleLock = (documentType) => {
        this.setState({
            locked: true
        }, this.props.onHandleLockingDocument('lock', documentType))
    }

    onToggleModal = () => {
        this.setState({
            showModal: this.state.showModal ? false : true
        });
    }

    onCloseModal = () => {
        if(this.fileInput2) this.fileInput2.value = "";
        this.setState({
            donationsFile: null,
            showModal: false,
            accept: false
        })
    }

    _handleDeleteDonationFile = (e) => {
        e.preventDefault();
        this.setState({
            donationsFile: null,
            accept: false,
        });
        // Clear file values from state, so they won't get uploaded again
        this.removeDonationsFileFromState();
    }
    
    _handleDeleteDonationFileFromServer = () => {
        this.setState({
            currentDonation: false
        });
        // Clear file values from state, so they won't get uploaded again
        this.removeDonationsFileFromState();
        // After this we do the actual deleting from the server
        if(this.props.currentDonationId) this.props.deleteDocumentFromServer(this.props.currentDonationId);
    }

    removeDonationsFileFromState = () => {
        this.props.onHandleFileDelete('donations');
    }

    _onHandleDownloadFile = (id, filename) => {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token, 'Content-Type' : 'application/pdf'};
        const url = APP_URL_API + 'files/' + id + '/download';

        this.serverRequest =
            axios
                .get(url, {responseType: 'arraybuffer', headers: config})
                .then(function(response) {
                    fileDownload(response.data, filename);
                })
    }

    _onHandleApproveDocument = (documentId) => {
        // Call API 
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'files/' + documentId + '/approveDocument';
        const data = {};
        data._method = "patch";

        this.serverRequest =
            axios
                .post(url, data, {headers: config})
                .then(function(response) {
                    this.setState({
                        donationWaitingForApproval: false,
                        locked: true
                    })
                }.bind(this))
    }

    _onHandleRejectDocument = (documentId) => {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'files/' + documentId;

        this.serverRequest =
            axios
                .delete(url, {headers: config})
                .then(function(response) {
                    this.setState({
                        donationWaitingForApproval: false, 
                        locked: false
                    })
                }.bind(this))        
    }

    onHandleRedirectToDonations = () => {
        this.props.history.push('/admin/organization/' + this.props.organizationId + '/donations/year/' + this.props.year);
    }

    render() {
        const advancedInterface = this.props.advancedInterface;
        const locked = advancedInterface ? this.state.locked : this.props.locked;
        const noDonationFile = advancedInterface && parseInt(this.props.currentDonation.amount_total) === 0;
        const documentType = advancedInterface ? "donations" : "annualReport";
        const {
            year, 
            currentDonation,
            currentDonationName, 
            currentDonationId,
            donationsFile,
            currentAnnualReportInherited,
            user,
            donationWaitingForApproval,
            donationCommunity,
            formDataUpdated
        } = this.props;
        
        return (
            <div className="flex gap-4 items-center flex-1 shrink px-4">
                {this.state.currentAnnualReport || (this.state.currentDonation && advancedInterface) ?
                    <div className="flex flex-col gap-4">

                        {currentAnnualReportInherited && donationCommunity &&
                            <DonationFile
                            currentDonation={donationCommunity}
                            currentDonationName={donationCommunity.filename}
                            currentDonationId={donationCommunity.id}
                            attached={true}
                            _onHandleDownloadFile={this._onHandleDownloadFile}
                        />
                        }

                        <div className="flex gap-4 items-start">                            
                            
                            <div className="flex flex-col gap-2">
                                {!noDonationFile && currentDonationId && 
                                <DonationFile
                                    currentDonation={this.state.currentDonation}
                                    currentDonationName={currentDonationName}
                                    currentDonationId={currentDonationId}
                                    file={donationsFile}
                                    _onHandleDownloadFile={this._onHandleDownloadFile}
                                />
                                }
                                
                                { advancedInterface && 
                                    <DonationsMeta currentDonation={currentDonation} /> }
                                
                                { !currentAnnualReportInherited && !advancedInterface && 
                                    <DonationsMeta currentAnnualReportContent={this.state.currentAnnualReportContent} /> }
                            </div>

                            {!currentAnnualReportInherited && currentDonationId &&
                                <Lock 
                                    user={user}
                                    locked={locked}
                                    handleUnLock={(documentType) => this.handleUnLock(documentType)}
                                    handleLock={(documentType) => this.handleLock(documentType)}
                                    advancedInterface={advancedInterface}
                                    documentType={documentType}
                                />
                            }

                            {this.state.currentDonation &&
                                <DeleteDonationsFile
                                    user={user}
                                    currentDonation={this.state.currentDonation}
                                    handleDeleteFile={this._handleDeleteDonationFile}
                                    handleDeleteFileFromServer={this._handleDeleteDonationFileFromServer}
                                    file={donationsFile}
                                />
                            }
                        
                        </div>

                        {this.state.donationWaitingForApproval && advancedInterface && <WaitingForApproval 
                                year={year} 
                                document={donationWaitingForApproval}
                                onHandleDownloadFile={this._onHandleDownloadFile}
                                onHandleApproveDocument={this._onHandleApproveDocument}
                                onHandleRejectDocument={this._onHandleRejectDocument}
                                user={user} />
                            }
                        {!locked && !this.state.donationWaitingForApproval && advancedInterface && !currentAnnualReportInherited &&
                            <div>
                                {formDataUpdated ? 
                                    <button className="button button--small" onClick={(e) => 
                                        { e.preventDefault();
                                            if (window.confirm('Der er foretaget ændringer som kan gå tabt, hvis du ikke gemmer inden du indberetter oplysninger om donationer. Vil du fortsætte?')) 
                                                this.onHandleRedirectToDonations(e) }}>Indberet oplysninger om donationer</button>
                                :
                                    <button className="button button--small" onClick={this.onHandleRedirectToDonations}>Indberet oplysninger om donationer</button>
                                
                                }
                            </div>
                        }
                    </div>
                :
                    <div className="flex flex-col gap-4">
                    {this.state.currentAnnualReport && <DonationsMeta currentAnnualReportContent={this.state.currentAnnualReportContent} />}
                    {advancedInterface &&
                        <div>
                            <DonationFile
                        currentDonation={this.state.currentDonation}
                        currentDonationName={currentDonationName}
                        currentDonationId={currentDonationId}
                        file={donationsFile}
                        _onHandleDownloadFile={this._onHandleDownloadFile}
                    />
                        {!currentAnnualReportInherited &&
                            <div>
                                {formDataUpdated ? 
                                    <button className="button button--small" onClick={(e) => 
                                        { e.preventDefault();
                                            if (window.confirm('Der er foretaget ændringer som kan gå tabt, hvis du ikke gemmer inden du indberetter oplysninger om donationer. Vil du fortsætte?')) 
                                                this.onHandleRedirectToDonations(e) }}>Indberet oplysninger om donationer</button>
                                :
                                    <button className="button button--small" onClick={this.onHandleRedirectToDonations}>Indberet oplysninger om donationer</button>
                                }
                            </div>
                        }
                        </div>

                    }
                    </div>
                }

            <Modal visible={this.props.showAlertModal}>
                <p>{this.props.modalText}</p>
                <div style={{marginTop: '3em', textAlign: 'right', minWidth: '400px'}}>
                    <button type="button" className="button" onClick={this.props.closeAlertModal}>Ok</button>
                </div>
            </Modal>

            </div>
        )
    }
}

export default withRouter(Donations);

const WaitingForApproval = (props) => {
    if(props.document) {
    return (
        <div className="approvalPanel approvalPanel--small">
            <div style={{fontSize: '12px'}}>Afventer godkendelse</div>
            {parseInt(props.document.amount_total) === 0 ? 
                "Har ikke modtaget donationer" 
                :
                <div style={{cursor: 'pointer'}} onClick={() => props.onHandleDownloadFile(props.document.id, props.document.filename)}>{props.document.filename}</div>
            }
            {props.user.type === 'admin' &&
            <div className="flex gap-2 pt-1">
                <img src="/images/assets/vhvid.svg" alt="Godkend"
                    onClick={() => { if (window.confirm('Er du sikker på at du vil godkende bilaget vedr. donationer?')) props.onHandleApproveDocument(props.document.id) }} style={{cursor: 'pointer'}} />
                <img src="/images/assets/krydshvid.svg" alt="Afvis"
                    onClick={() => { if (window.confirm('Hvis du afviser bliver filen slettet permanent')) props.onHandleRejectDocument(props.document.id) }} style={{cursor: 'pointer'}} />    
            </div>
            }
        </div>
    );
    } else {
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/modules/reports/Donations.js